import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActionTabletLprItemComponent } from './action-tablet-lpr-item/action-tablet-lpr-item.component';
import { CommonLayoutModule, CommonTranslationModule, CommonUIElementsModule, CommonUIFieldsModule } from '@sdbn/common';
import { ActionTabletModule, ActionTabletRegistryService } from '@sdbn/appclient';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';



@NgModule({
  declarations: [
    ActionTabletLprItemComponent
  ],
  imports: [
    CommonModule,
    ActionTabletModule,
    CommonLayoutModule,
    CommonUIFieldsModule,
    CommonUIElementsModule,
    CommonTranslationModule,
    ReactiveFormsModule,
    FormsModule
  ]
})
export class ActionTabletLprItemModule {

  constructor(actionTabletRegistryService: ActionTabletRegistryService) {

    actionTabletRegistryService.registerType('lpr', ActionTabletLprItemComponent);

  }

}
